
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labcollector",
      function () {
        return require("private-next-pages/labcollector/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labcollector"])
      });
    }
  